var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iconSearch",
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17.8269L12.8158 12.2885C13.9526 11.0885 14.6158 9.42692 14.6158 7.67308C14.7105 3.88846 11.4895 0.75 7.60526 0.75C3.72105 0.75 0.5 3.88846 0.5 7.67308C0.5 11.4577 3.62632 14.5962 7.60526 14.5962C9.21579 14.5962 10.6368 14.0423 11.8684 13.2115L17.5526 18.75L18.5 17.8269ZM1.92105 7.67308C1.92105 4.62692 4.47895 2.13462 7.60526 2.13462C10.7316 2.13462 13.2895 4.62692 13.2895 7.67308C13.2895 10.7192 10.7316 13.2115 7.60526 13.2115C4.47895 13.2115 1.92105 10.7192 1.92105 7.67308Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.769fdcdaa0442a73cf61104345ad7195.svg";
export { ForwardRef as ReactComponent };